import React, { useEffect } from 'react';
import { Formik, Form, Field } from 'formik';
import { Button } from '@mui/material';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const SearchBar = props => {
  const { languageData, onBack } = props;
  return (
    <FlexContainer className={'SearchBar margt60 align-items-end'}>
      <i class="fa fa-chevron-left" onClick={onBack}></i>
      <Label className={'fontWhite text-12 margl10'} onClick={onBack}>
        {languageData === 'EN'
          ? 'Back to Reservation Details'
          : 'Volver al detalle de reservación'}
      </Label>
    </FlexContainer>
  );
};

const PaymentCardForm = props => {
  const { initialValues, onSubmit, loading, languageData, onRegister } = props;
  return (
    <FlexContainer className={'flex-column margtb20'}>
      <Formik initialValues={initialValues} onSubmit={onSubmit}>
        {({ isSubmitting }) => (
          <Form className={'width100'} style={{ maxWidth: '400px' }}>
            <Button
              className={''}
              type="submit"
              fullWidth
              sx={{
                mt: '30px',
                py: 0.8,
                border: '2px solid rgba(255,255,255)',
                color: 'rgba(255,255,255,0.9)',
                borderRadius: '10px',
                textTransform: 'none',
                transition: 'all 0.2s ease',
                fontSize: '16px',
                '&:hover': {
                  transform: 'translateY(-1px)',
                },
                '&:disabled': {
                  opacity: 0.7,
                },
              }}
              disabled={loading || isSubmitting}
            >
              {loading
                ? languageData === 'EN'
                  ? 'Loading...'
                  : 'Cargando...'
                : languageData === 'EN'
                ? 'Continue'
                : 'Continuar'}
            </Button>
          </Form>
        )}
      </Formik>
    </FlexContainer>
  );
};

const PaymentCardView = props => {
  const { initialValues, onSubmit, loading, onBack, onRegister, languageData } =
    props;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <FlexContainer className="flex-column padlr10 justify-start items-center  bgGradientBlue fontWhite height-550px">
      <SearchBar languageData={languageData} onBack={onBack} />
      <FlexContainer className={'flex-column padlr20 margb30'}>
        <FlexContainer className="justify-between items-center width-100 margtb10 items-align-start">
          <Label
            className="text-28 whitespace-preline lineHeight-1-1 fontWhite"
            style={{
              fontWeight: 500,
            }}
          >
            {languageData === 'EN' ? 'Payment \nCard' : 'Tarjeta de \nPago'}
          </Label>

          <button
            className="margt22 flex-container align-items-center justify-center gap-6 bgTransparent fontWhite padtb10 padlr12 borderrad50 text-10 pointer lineHeight-1"
            style={{
              border: '2px solid rgba(255,255,255)',
              fontWeight: 500,
              transition: 'all 0.2s ease',
            }}
            onMouseOver={e => {
              e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)';
              e.currentTarget.style.borderColor = 'rgba(255,255,255,0.8)';
            }}
            onMouseOut={e => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.borderColor = 'rgba(255,255,255,0.6)';
            }}
          >
            <i className="fas fa-plus text-10 margt1"></i>
            {languageData === 'EN' ? 'New Card' : 'Nueva Tarjeta'}
          </button>
        </FlexContainer>

        <Label className={'text-12 margt10'}>
          {languageData === 'EN'
            ? 'Saved card on file for quick checkout.'
            : 'Tarjeta guardada para pago rápido.'}
        </Label>
        <Label className={'text-12 margb10 whitespace-preline'}>
          {languageData === 'EN'
            ? 'For your security, only the last \nfour digits are shown.'
            : 'Para tu seguridad, solo se muestran \nlos últimos cuatro dígitos.'}
        </Label>
        <PaymentCardForm
          languageData={languageData}
          onBack={onBack}
          initialValues={initialValues}
          onSubmit={onSubmit}
          loading={loading}
          onRegister={onRegister}
        />
      </FlexContainer>
    </FlexContainer>
  );
};

export default PaymentCardView;
